import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";
import {
  MIDDLE_WARE_BASE_URL_v1,
  REVOKE_CANDIDACY,
} from "../../../utils/CONSTANTS";

const initialState = {
  revokeCandidacyState: "pending",
  revokeCandidacyData: null,
  revokeCandidacyMessage: "",
};

export const revokeCandidacy = createAsyncThunk(
  "post/revokeCandidacy",
  async (data: any) => {
    const response = axios.postRequest(
      MIDDLE_WARE_BASE_URL_v1() + REVOKE_CANDIDACY(),
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  }
);

const revokeCandidacySlice = createSlice({
  name: "revokeCandidacy",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(revokeCandidacy.pending, (revokeCandidacyState) => {
        revokeCandidacyState.revokeCandidacyState = "pending";
      })
      .addCase(revokeCandidacy.fulfilled, (revokeCandidacyState, action) => {
        let tempRes = action.payload;
        if (typeof tempRes === "string") {
          tempRes = JSON.parse(tempRes);
        }

        revokeCandidacyState.revokeCandidacyState = "fulfilled";
        revokeCandidacyState.revokeCandidacyData = tempRes;
        revokeCandidacyState.revokeCandidacyMessage = tempRes
          ? tempRes.message
          : "";
        //console.log("Insisde Slice ", tempRes);
      })
      .addCase(revokeCandidacy.rejected, (revokeCandidacyState) => {
        revokeCandidacyState.revokeCandidacyState = "failed";
      }),
});

export const revokeCandidacyDetails = (state: any) => state.revokeCandidacy;

export default revokeCandidacySlice.reducer;
